import React from "react";
import HeroCarousel from "../components/HeroCarousel";
import ProductCategories from "../components/ProductCategories";
import LeduroAdvantages from "../components/LeduroAdvantages";
import Testimonials from "../components/Testimonials";
import PartnersMarquee from "../components/PartnersMarquee";
import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck, Truck, Headphones, FileSpreadsheet } from "lucide-react";

const QUICK = [
  { Icon: ShieldCheck, title: "Up to 5-year warranty", text: "Standard across panels, ext. for projects." },
  { Icon: Truck, title: "Ship in 24h", text: "Stock-keeping units delivered Baltics-wide." },
  { Icon: FileSpreadsheet, title: "Full datasheets", text: "IES/LDT files for every SKU, on request." },
  { Icon: Headphones, title: "Trade support", text: "Same-day technical answers from real engineers." },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroCarousel />

      {/* Quick value strip */}
      <section className="border-b border-leduro-border bg-white" data-testid="quick-value">
        <div className="leduro-container grid grid-cols-2 lg:grid-cols-4 divide-x divide-leduro-border">
          {QUICK.map(({ Icon, title, text }, i) => (
            <div key={i} className="flex items-start gap-4 py-6 px-4 lg:px-8 first:pl-0 last:pr-0">
              <div className="h-11 w-11 grid place-items-center bg-leduro-surface border border-leduro-border shrink-0">
                <Icon className="h-5 w-5 text-leduro-orange" />
              </div>
              <div>
                <div className="font-heading font-bold text-leduro-navy text-sm">{title}</div>
                <div className="text-xs text-leduro-muted leading-relaxed mt-1">{text}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ProductCategories />
      <LeduroAdvantages />

      {/* Featured project CTA */}
      <section className="relative bg-white py-20 md:py-28" data-testid="project-cta">
        <div className="leduro-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-7 relative">
              <div className="relative aspect-[16/10] overflow-hidden border border-leduro-border">
                <img
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80"
                  alt="Warehouse retrofit"
                  className="h-full w-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-leduro-navy/90 to-transparent p-6">
                  <p className="text-white/70 text-xs uppercase tracking-widest font-semibold">Case · NorthLogix DC</p>
                  <p className="text-white font-heading font-bold text-xl mt-1">
                    40,000 m² warehouse retrofit · 612 luminaires
                  </p>
                </div>
              </div>
              <div className="absolute -top-6 -right-6 hidden md:flex flex-col bg-leduro-orange text-white p-6 w-44">
                <span className="text-[10px] tracking-[0.24em] uppercase font-bold">Energy saved</span>
                <span className="font-heading font-black text-5xl leading-none mt-1">62%</span>
                <span className="text-[11px] mt-2 leading-snug">vs. previous fluorescent install</span>
              </div>
            </div>

            <div className="lg:col-span-5">
              <span className="leduro-eyebrow">— Project Spotlight</span>
              <h2 className="mt-3 font-heading font-black tracking-tighter text-leduro-navy text-3xl md:text-4xl text-balance">
                We don't just ship boxes. We help you spec it right.
              </h2>
              <p className="mt-5 text-leduro-muted leading-relaxed">
                From photometric simulation to on-site commissioning support, our trade team works alongside
                contractors to deliver projects that pass acceptance the first time.
              </p>
              <ul className="mt-6 space-y-3 text-sm">
                {[
                  "DIALux & Relux files for any SKU on request",
                  "On-site sampling for projects over 100 units",
                  "Tendering documentation aligned to EU procurement standards",
                  "Dedicated account engineer for repeat trade buyers",
                ].map((t) => (
                  <li key={t} className="flex items-start gap-3 text-leduro-navy">
                    <span className="mt-1.5 h-1.5 w-1.5 bg-leduro-orange rounded-full shrink-0" />
                    <span className="text-leduro-text">{t}</span>
                  </li>
                ))}
              </ul>
              <Link to="/where-to-find" data-testid="project-cta-link" className="leduro-btn-primary mt-8">
                Start a project conversation
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Testimonials />
      <PartnersMarquee />
    </div>
  );
}
